export default __webpack_public_path__ + "static/media/logo.e85cf099.svg";